import { Component, OnInit } from '@angular/core';
import { IFornecedorForm, IMateriais } from './cadastrar-fornecedor-layout.model';
import { HttpService } from '../../../services/common/http/common.http.service';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';

type IOptions = {
  name: string;
  value: string | number;
};

@Component({
  selector: 'app-cadastrar-fornecedor-layout',
  templateUrl: './cadastrar-fornecedor-layout.component.html',
  styleUrls: ['./cadastrar-fornecedor-layout.component.scss'],
})
export class CadastrarFornecedorLayoutComponent implements OnInit {
  isEditing: boolean = false;
  loader: boolean = false;

  constructor(
    private httpService: HttpService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.activateRoute();
    this.getMateriais();
  }

  form: IFornecedorForm = {
    NmFornecedor: '',
    TxEmailFornecedor: '',
    TxTelefoneFornecedor: '',
    TxEnderecoFornecedor: '',
    TxObservacaoFornecedor: '',
    VlPrecoFreteFornecedor: 0,
    QtDiaPrevisto: 0,
    Materiais: [],
  };

  materiaisOptions: IOptions[] = [
    {
      name: '',
      value: '',
    },
  ];

  materialList: any = [];

  changeSelect(event: any) {
    let material: any[] = [];

    event.forEach((element: any) => {
      material.push(this.materiaisOptions.find((x) => x.value === Number(element)));
    });

    this.materialList = this.findNameMaterial(material, event);

    this.form.Materiais = this.findValueMaterial(material, event) as IMateriais[];
  }

  findNameMaterial(list: any[], value: any) : IMateriais[] {
    let nomeMaterial: IMateriais[] = [];
    let foundItems;

    value.forEach((element: any) => {
      foundItems = list.filter((item) => item?.value === element);
      nomeMaterial.push(...foundItems.map((item) => item.name));
    });

    return nomeMaterial
  }

  findValueMaterial(list: any[], value: any) {
    let idmaterial: any[] = [];
    let foundItems;

    value.forEach((element: any) => {
      foundItems = list.filter((item) => item?.value === element);

      idmaterial.push(...foundItems.map((item) => item.value));
    });

    return idmaterial ? idmaterial : null;
  }
  
  getMateriais() {
    this.loader = true;

    return this.httpService.useGet('Materiais').subscribe({
      next: (response: any) => {
        this.materiaisOptions = response.map((x: any) => {
          return {
            name: x.NmMaterial,
            value: x.IdMaterial,
          };
        });
      },
      error: (_error: any) => {
        this.loader = false;
        Swal.fire({
          title: 'Atenção',
          text: 'Não foi possível buscar listagem. Tente novamente!',
          icon: 'warning',
          confirmButtonText: 'Confirmar',
          confirmButtonColor: 'Green',
        });
      },
      complete: () => {
        this.activateRoute();
      },
    });
  }

  postForm() {
    if (!this.isEditing) {
      this.createFornecedor();
    }
    if (this.isEditing) {
      this.editFornecedor();
    }
  }

  createFornecedor() {
    this.loader = true;
    this.httpService.usePostFilter('CreateFornecedor', this.form).subscribe({
      next: (res) => {
        Swal.fire({
          title: 'Sucesso!',
          text: 'Fornecedor cadastrado com sucesso.',
          icon: 'success',
          confirmButtonText: 'Ok',
          confirmButtonColor: 'green',
        }).then(() => {
          this.router.navigate(['fornecedores']);
        });
      },
      error: (err) => {
        Swal.fire({
          title: 'Erro!',
          text: 'Erro ao cadastrar o fornecedor.',
          icon: 'error',
          confirmButtonText: 'Ok',
          confirmButtonColor: 'red',
        });
        this.loader = false;
      },
      complete: () => {
        this.loader = false;
      },
    });
  }

  editFornecedor() {
    this.loader = true;
    const params = {
      id: this.form.IdFornecedor,
    };
    this.httpService
      .usePut('UpdateFornecedor', this.form, params)
      .add(
        () => ((this.loader = false), this.router.navigate(['fornecedores']))
      );
  }

  updateMateriais(materiais: any) {
    if (this.isEditing) {
      const materiaisToAdd = materiais.map((material: any) => {
        return {
          NmMaterial: material.name,
          MaterialId: material.value,
          VlMaterial: 0.01,
        };
      });
      this.form.Materiais = [...this.form.Materiais, ...materiaisToAdd];
      return;
    }
    this.form.Materiais = materiais.map((material: any) => {
      return {
        NmMaterial: material.name,
        MaterialId: material.value,
        VlMaterial: 0.01,
      };
    });
  }

  validarForm(): boolean {
    if (
      this.form.NmFornecedor &&
      this.form.TxTelefoneFornecedor.length >= 10 &&
      this.form.TxEnderecoFornecedor &&
      this.form.Materiais.length &&
      this.form.VlPrecoFreteFornecedor &&
      this.form.QtDiaPrevisto
    ) {
      return false;
    }
    return true;
  }

  activateRoute(): void {
    this.loader = true;
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params) {
        const id = +params['id'];
        if (!id) {
          this.loader = false;
          return;
        }
        this.isEditing = true;
        this.httpService
          .useGet('FornecedorByFilter', { IdFornecedor: id })
          .subscribe({
            next: (res: any) => {
              const data = res.DataSet[0];
              this.form.IdFornecedor = data.IdFornecedor;
              this.form.NmFornecedor = data.NmFornecedor;
              this.form.TxEmailFornecedor = data.TxEmailFornecedor;
              this.form.TxTelefoneFornecedor = data.TxTelefoneFornecedor;
              this.form.TxEnderecoFornecedor = data.TxEnderecoFornecedor;
              this.form.TxObservacaoFornecedor = data.TxObservacaoFornecedor;
              this.form.VlPrecoFreteFornecedor = data.VlPrecoFreteFornecedor;
              this.form.QtDiaPrevisto = data.QtDiaPrevisto;
              this.form.Materiais = data.Materiais.map((material: any) => {
                return {
                  NmMaterial: material.NmMaterial,
                  MaterialId: material.IdFornecedorMaterial,
                  VlMaterial: material.VlMaterial,
                };
              });
            },
            error: (err: any) => {},
            complete: () => {
              this.loader = false;
            },
          });
      }
    });
  }
}
